import { produce } from 'immer';

import { UpdateInternalMarketersPageStatus } from '../../../actions/marketers/internal/updateInternalMarketersPageStatus';
import { MarketersState } from '../../../typings/marketers';

export function updateInternalMarketersPageStatus(
    state: MarketersState,
    action: UpdateInternalMarketersPageStatus
): MarketersState {
    return produce(state, draft => {
        draft.pageStatus = action.status;
    });
}
